export default "__VITE_ASSET__427007bf__"